import React, { useEffect, useRef, useState } from "react"
import { FlatList, ActivityIndicator, ScrollView, StyleSheet, Switch, Text, TouchableOpacity, View } from "react-native"
import { MyButton } from "./buttonsAndControls"
import { Checkbox, IconButton, Modal, Portal, TextInput, Provider as PaperProvider } from "react-native-paper"
import { branch, companyDir, header, stopCodes } from "./StockAwareTempData"
import { DEBUG, enablePromise, openDatabase } from "react-native-sqlite-storage"
import DateModule from "./mainAppDateModule"
import { useNavigation } from "@react-navigation/native"
import { addDoc, collection, deleteDoc, getDoc, getDocs, getFirestore, orderBy, query, serverTimestamp, where } from "firebase/firestore"

const darkColour='#2a2d3e'

interface ChildViewData {
	id: string;
	texts: string[];
}

interface SalesList {
	id: string;
	salesId: string;
	quantity: number;
	board: string;
	customer: string;
	paymentMethod: string;
	date: string;
	delivered: string;
	notes: string;
	itemPrice: number;
	total: number;
	discount: number;
	afterDiscount: number;
};

const ChildView = ({
texts,
isChecked,
onCheckboxChange,
showCheckbox,
index,
Delivered,
noClicked,
}: ChildViewData & {
isChecked: boolean;
onCheckboxChange: (value: boolean) => void;
showCheckbox: boolean;
index: number;
Delivered: boolean;
noClicked: ()=> void;

}) => {
	const isEvenIndex = index % 2 === 0;
	const backgroundColor = Delivered ? '#EECE17' : isEvenIndex ? '#E6E6E6' : '#F5F5F5';
	const remarkWidth= showCheckbox ? 300 : 336
	const sizes: number[] = [57, 331, 185, 117, remarkWidth, 102, 152, 120, 180];
  return (
    <View style={{ backgroundColor}}>
      <TouchableOpacity
        style={{
          flexDirection: 'row',
          alignItems: 'center',
          backgroundColor: isChecked ? darkColour : 'transparent',
          height:35,
					width:1556,
          borderColor:'black',
          borderTopWidth:2,
          borderBottomWidth:2,
          marginTop:-2,
          
        }}
        onPress={() => onCheckboxChange(!isChecked)}
      >
        {showCheckbox && (
          <Checkbox
            status={isChecked ? 'checked' : 'unchecked'}
            onPress={() => onCheckboxChange(!isChecked)}
            color= 'white'
          />
        )}
      {texts.map((text, i) => (
      
        <View
        key={i} 
        style={{
            width:(sizes[i]), 
            borderWidth:2, 
            borderColor:'black', 
            height: 35, 
            alignItems:'center', 
            marginLeft:-2, 
            borderTopWidth:0, 
            borderBottomWidth:0,
            
            }}>
							{text === 'No' ? 
							<TouchableOpacity style = {{width: (sizes[i]), height: 35, 
								backgroundColor: '#2A6AA7',
							alignItems:'center', 
							marginLeft:-2, }}
							onPress={noClicked}>
								<Text 
							
							key={i} 
							style={{
									color: isChecked ? 'white' : 'white',
									fontFamily:'century gothic', 
									fontSize:15, 
									fontWeight:'normal',
									marginTop:6
									}}>
											{text}
							</Text>
							</TouchableOpacity>
							:
							
							<Text 
						
            key={i} 
            style={{
                color: isChecked ? 'white' : darkColour,
                fontFamily:'century gothic', 
                fontSize:15, 
                fontWeight:'normal',
                marginTop:6
                }}>
                    {text}
            </Text>
						}
            
        </View>
        
        ))}
      </TouchableOpacity>
    </View>
  );
};




const Sales =()=>{
		header('Sales Record')
    const [checkedItems, setCheckedItems] = useState<boolean[]>([]);
    const [isSwitchOn, setIsSwitchOn] = useState(false);
    const [searchText, setSearchText] = useState('');
		const [markedID, setMarkedID] = useState<boolean[]>([]);
    const [filteredResult, setFilteredResult] = useState<SalesList[]>([]);
	  const [sales, setSales] = useState<SalesList[]>([]);
    const [deleteArrayID, setDeleteArrayID] = useState<string[]>([]);
    const [grossTotal, setGrossTotal] = useState(' ');
		const [discount, setDiscount] = useState(' ');
		const [showModal, setShowModal] = useState(false);
		const [oneItemID, setOneItemID] = useState('');
		const [whoClicked, setWhoClicked] = useState('today')
		const [customDate, setCustomDate] = useState(false)
		const [footerText, setFooterText] = useState('Showing from today')
		const [showLoadingIndicator, setShowLoadingIndicator] = useState(true);
		let timeout: NodeJS.Timeout
		const scrollViewRef = useRef<ScrollView>(null);
		const [totalRows, setTotalRows] = useState(-1);
		const [holdTotal, setHoldTotal] = useState(' ');
		const stocksArray: SalesList[] = [];
		const [dateVisible, setDateVisible] = useState(false)
		const [clear, setClear] = useState(true)
		const [clearCheck, setClearCheck] = useState(false)
		const [correctDateTime, setCorrectDateTime] = useState([])
		const db = getFirestore();

		const receiptTime = {
			someField: 'receiptTime',
			receiptTime: serverTimestamp(),
		};

		const correctDate = async () => {
			try {
				const docRef = await addDoc(collection(db, companyDir, branch, 'receipt'), receiptTime);
		
				const documentSnapshot = await getDoc(docRef);
				if (documentSnapshot.exists()) {
					const data = documentSnapshot.data().receiptTime.toDate();
					const date = new Date(data);
					data.setHours(0, 0, 0, 0)
					// const date = new Date(data);
		
					// const day = String(date.getDate()).padStart(2, '0');
					// const month = String(date.getMonth() + 1).padStart(2, '0');
					// const year = date.getFullYear();
					// const hours = String(date.getHours()).padStart(2, '0');
					// const minutes = String(date.getMinutes()).padStart(2, '0');
					// const seconds = String(date.getSeconds()).padStart(2, '0');
					// const formattedDate = `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
		
					// Delete the document
					await deleteDoc(documentSnapshot.ref);
		
					// Return the formatted date
					return data;
				} else {
					console.log('Document does not exist.');
					return null;
				}
			} catch (error) {
				console.error('Error:', error);
				throw error; // Rethrow the error for the caller to handle
			}
		};

    const fetchSales = async (toSubtract: number) => {
     
			const salesColRef = collection(getFirestore(), companyDir, branch, 'salesItems');
			const salesRows: SalesList[] = [];

			(async () => {

				const endDate = new Date(correctDateTime[0]);
				endDate.setDate(endDate.getDate() - toSubtract)
				endDate.setHours(23, 59, 59, 999);
				
				const startDate = new Date(endDate);
				startDate.setHours(0, 0, 0, 0)
				console.log(startDate, endDate)
				const salesQuery = query(
					salesColRef, 
					where('date', '>=', startDate),
					where('date', '<=', endDate),
					orderBy('date', 'desc')
					);
				const salesSnapshot = await getDocs(salesQuery)

				setTotalRows(salesSnapshot.size)
				let afterDcnt = 0;
				let dcnt = 0;

				for (const salesDoc of salesSnapshot.docs) {
					const salesData = salesDoc.data()
					afterDcnt += salesData.afterDiscount;
					dcnt += salesData.discount;
					const stockArrayCol = {
						id: salesDoc.id,
						...salesData
					}

					salesRows.push(stockArrayCol as unknown as SalesList)
				}

				setGrossTotal(afterDcnt.toString())
				setDiscount(dcnt.toString())
				setSales(salesRows);
				setFilteredResult(salesRows);

				const updatedCheckedItems: boolean[] = Array.from(
					{ length: salesRows.length },
					() => false
				);
				setCheckedItems(updatedCheckedItems)

			})()
    }

		useEffect(() => {
		if (stopCodes) {
			setTimeout(() => {
				setClear(false)
				setClearCheck(true)
			}, 2000);
		}
		}, [stopCodes]);
	
		useEffect(() => {
			if (!clear) {
				const usecodes = async() => {
					await correctDate()
						.then((accurateDate) => {
							correctDateTime.unshift(accurateDate);
							fetchSales(0);
						})
				}
				usecodes();
			}
		}, [clearCheck]);

		useEffect(() => {
			if (!clear) {
			timeout = setTimeout(() => {
				if (totalRows !== -1 && filteredResult.length === totalRows) {
					setShowLoadingIndicator(true)
				}
			}, 10000);
			if (totalRows !== -1 && filteredResult.length === totalRows) {
				clearTimeout(timeout)
				setTimeout(() => {
						setShowLoadingIndicator(false)
						//setGrossTotal(holdTotal)
				}, 200);
			
			}
		}
		}, [totalRows, filteredResult, clearCheck]);
  
    useEffect(() => {
			if (!clear) {
			const filterChildViews = async () => {
				const filteredViews = await filterViews() as SalesList[];
				setFilteredResult(filteredViews);
			};
			filterChildViews();
		}
		}, [sales, checkedItems, isSwitchOn, searchText, clearCheck]);

		// useEffect(() => {
		// 	if (stopCodes && totalRows !== -1) {
		// 		let amt = 0
		// 		for (const entry of filteredResult) {
		// 			amt += entry.After_Discount
		// 		}
		// 		setGrossTotal(amt.toString())
		// 	}
		// }, [stopCodes, filteredResult]);

		const findIndexById = (array: any[], id: number | string): number => {
			return array.findIndex((item) => item.ID === id);
		};
		
		const handleCheckboxChange = (index: number, value: boolean, id: string) => {
			const updatedCheckedItems = [...checkedItems];
			updatedCheckedItems[index] = value;
			setCheckedItems(updatedCheckedItems);
	
			const idIndex = findIndexById(sales, id);
			const updatedMarkedID = [...markedID];
			updatedMarkedID[idIndex] = value;
			setMarkedID(updatedMarkedID);

      if (deleteArrayID.includes(id)) {
        setDeleteArrayID((prevDel) => prevDel.filter((value) => value !== id));
      } else {
      setDeleteArrayID((prevDel) => [...prevDel, id]);
      };
		};
	
		const handleSearchTextChange = (value: string) => {
			setSearchText(value);
		};

    const filterViews = async () => {
      return new Promise((resolve) => {
        setTimeout(() => {
          const filteredViews = sales.filter((child) => {
            const hasTextMatch = (child.board?.toLowerCase() + 
              child.paymentMethod?.toLowerCase() + 
                child.customer?.toLowerCase() + 
                  child.notes?.toLowerCase()).includes(searchText.toLowerCase())
            const hasIdMatch = child.id.toString().includes(searchText.toLowerCase());
            return hasTextMatch || hasIdMatch;
          });
  
          resolve(filteredViews);
        }, 0);
      });
    };
	
    const deleteCheckedItems = () => {
      const updatedCheckedItems = checkedItems.filter((_, index) => !checkedItems[index]);
      const updatedChildViews = sales.filter((_, index) => !markedID[index]);
    
      setCheckedItems(updatedCheckedItems);
      setSales(updatedChildViews);
      setMarkedID([]);
    
      markedForDelete();
    };

    const markedForDelete = async () => {
      DEBUG(true);
      enablePromise(true);
      const initDB =  openDatabase({name: 'StockAware.db', location:'default'});
      (await initDB).transaction((tx) => {
        deleteArrayID.forEach((row) => {
          tx.executeSql(
            `DELETE FROM Sales_Items WHERE ID = ?;`,
            [row],
            (_, results) => {
            if (results.rowsAffected > 0) {
              console.log('Deleted Successfully')
            }
              
            },
            (error) => {
              console.error('Error executing SQL', error);
            }
          );
        })
      })
      setDeleteArrayID([])
    };

		const updateDeliveryStatus = async (id: string) => {
			DEBUG(true);
			enablePromise(true);
			const initDB =  openDatabase({name: 'StockAware.db', location:'default'});
      (await initDB).transaction((tx) => {
				tx.executeSql(
				"UPDATE Sales_Items SET Delivered = ? WHERE ID = ?",
				['Yes', parseInt(id, 10)],
				(_, result) => {
					if (result.rowsAffected > 0) {
						const itemRow = filteredResult.find((item) => item.id === id);
                itemRow ? itemRow.delivered = 'Yes' : 'No'
								setShowModal(false)
					}
				}
			);
			})
		}
	
		
		const onToggleSwitch = () => {
			setIsSwitchOn(!isSwitchOn);
		};

		const SmallDialog = (itemID: string) => {
			setShowModal(true)
			setOneItemID(itemID)
     
		}
		
		function getOrdinalSuffix(number: number): string {
			if (number >= 11 && number <= 13) {
				return number + 'th';
			} else {
				const lastDigit = number % 10;
				switch (lastDigit) {
					case 1:
						return number + 'st';
					case 2:
						return number + 'nd';
					case 3:
						return number + 'rd';
					default:
						return number + 'th';
				}
			}
		};

		const searchDateSelected = async (start: string, end: string, month: string, monthName: string, year: string) => {
			if (end !== '00') {
				setFooterText(
					`Showing from ${getOrdinalSuffix(parseInt(start, 10))} ${monthName}, ${year} to ${getOrdinalSuffix(parseInt(end, 10))} ${monthName}, ${year}`
					)
				setShowLoadingIndicator(true)
				setGrossTotal(' ');
				setDiscount(' ');
				setCustomDate(true)

				const salesColRef = collection(getFirestore(), companyDir, branch, 'salesItems');
				const salesRows: SalesList[] = [];

				(async () => {

					const endDate = new Date(correctDateTime[0]);
					endDate.setFullYear(Number(year), Number(month) - 1, Number(end))
					endDate.setHours(23, 59, 59, 999);
					
					const startDate = new Date(correctDateTime[0]);
					startDate.setFullYear(Number(year), Number(month) - 1, Number(start))
					startDate.setHours(0, 0, 0, 0)
					console.log(startDate, endDate)
					const salesQuery = query(
						salesColRef, 
						where('date', '>=', startDate),
						where('date', '<=', endDate),
						orderBy('date', 'desc')
						);
					const salesSnapshot = await getDocs(salesQuery)

					setTotalRows(salesSnapshot.size)
					let afterDcnt = 0;
					let dcnt = 0;

					for (const salesDoc of salesSnapshot.docs) {
						const salesData = salesDoc.data()
						afterDcnt += salesData.afterDiscount;
						dcnt += salesData.discount;
						const stockArrayCol = {
							id: salesDoc.id,
							...salesData
						}

						salesRows.push(stockArrayCol as unknown as SalesList)
					}

					setGrossTotal(afterDcnt.toString())
					setDiscount(dcnt.toString())
					setSales(salesRows);
					setFilteredResult(salesRows);

					const updatedCheckedItems: boolean[] = Array.from(
						{ length: salesRows.length },
						() => false
					);
					setCheckedItems(updatedCheckedItems)

				})()
			}
		}

		const todayClicked = async () => {
			if (whoClicked !== 'today') {
				setFooterText('Showing from today')
				setWhoClicked('today')
				setShowLoadingIndicator(true)
				setGrossTotal(' ');
				setDiscount(' ');
				setDateVisible(false)
				setCustomDate(false)
				fetchSales(0);
			} 
		}

		const yesterdayClicked = async () => {
			if (whoClicked !== 'yesterday') {
				setFooterText('Showing from yesterday')
				setWhoClicked('yesterday')
				setShowLoadingIndicator(true)
				setGrossTotal(' ')
				setDiscount(' ');
				setDateVisible(false)
				setCustomDate(false)
				fetchSales(1);
			}
					
		}

		const customClicked = () => {
			setWhoClicked('custom')
			setDateVisible(true)
		}

		const switchText = isSwitchOn ? 'Checkbox shown' : 'Checkbox hidden'

    return(
			<PaperProvider>

      <View  style={{width:1600, height:778}} >
          <View  style={{ flexDirection: 'row', width:1560, height:64, backgroundColor:'white', borderWidth:2, borderRadius:10, marginLeft:20, marginRight:20, borderColor:'#DCE3E8'}}>
						<View style={{borderWidth:2, 
							borderRadius:10, 
							borderColor:'#DCE3E8', 
							flexDirection:'row', 
							alignSelf:'center', 
							alignContent:'center',
							width:208,
							height: 40,
							margin:20,
							marginTop:0,
							marginBottom:0

							
							}}>
							<Switch 
								value={isSwitchOn} 
								onValueChange={onToggleSwitch} 
								thumbColor={isSwitchOn ? 'white' : darkColour} 
								trackColor={{ false: 'transparent', true: darkColour }}
								style={{marginTop:-2,
								marginLeft:8
								}}
								
							/>
							<Text style={{...stylesBox.columnHeaderText, color: darkColour, marginTop:8}}>
								{switchText}
							</Text>
						</View>
						
						<View style={{flexDirection:'column', backgroundColor:'white', alignSelf:'center', borderWidth:2, borderColor: '#DCE3E8', borderRadius:10, marginLeft:10, marginTop:10, marginBottom:10, width:634, height:40}}>
							<View style={{flexDirection:'row', width:634, height:40}}> 
								<TextInput
									mode="outlined"
									label={'Search record'}
									placeholder="Search"
									underlineColor={darkColour}
									activeOutlineColor={darkColour}
									spellCheck={false}
									contentStyle={{
										paddingTop: 2, 
										paddingBottom:0,
										borderWidth:2, 
										borderRightWidth:0,
										borderRightColor:'white',
										width: 300, 
										height:30, 
										borderRadius:10, 
										borderTopRightRadius:0,
										borderBottomRightRadius:0,
										borderColor: 'transparent',
										
									}} 
									style={{marginTop:-1, height:30 }}
									outlineStyle={{ borderWidth: 0, height:30, borderRightColor:'white', }}
									onChangeText={handleSearchTextChange}
									
									
								/>

					<View style={{
						alignSelf:'center', 
						marginLeft:-2, 
						height:40, 
						width:95,
						borderWidth:2, 
						borderColor: 'transparent', 
						borderTopRightRadius:10,
						borderBottomRightRadius:10, 
						marginRight:10, 
						borderLeftWidth:0, 
						marginTop:0, 
						alignContent:'center'
						}}>
						<MyButton btnText="Today"
						btnBorClr={darkColour}
						btnBorRadius={10}
						btnBorWdt={2}
						btnColor={whoClicked === 'today' ? darkColour : 'white'}
						btnFontSize={15}
						btnHeight={32}
						btnWidth={95}
						btnTxtClr={whoClicked === 'today' ? 'white' : darkColour}
						btnPadding={4}
						hndClicked={todayClicked}
					/>
					</View>

					<View style={{
						alignSelf:'center', 
						marginLeft:-2, 
						height:40, 
						width:95,
						borderWidth:2, 
						borderColor: 'transparent', 
						borderTopRightRadius:10,
						borderBottomRightRadius:10, 
						marginRight:10, 
						borderLeftWidth:0, 
						marginTop:0, 
						alignContent:'center'
						}}>
						<MyButton 
							btnText="Yesterday" 
							btnBorClr={darkColour}
							btnBorRadius={10}
							btnBorWdt={2}
							btnColor={whoClicked === 'yesterday' ? darkColour : 'white'}
							btnFontSize={15}
							btnHeight={32}
							btnWidth={95}
							btnTxtClr={whoClicked === 'yesterday' ? 'white' : darkColour}
							btnPadding={4}
							hndClicked={yesterdayClicked}
						 />
					</View>

					<View style={{
						alignSelf:'center', 
						marginLeft:-2, 
						height:40, 
						width:110,
						borderWidth:2, 
						borderColor: 'transparent', 
						borderTopRightRadius:10,
						borderBottomRightRadius:10, 
						marginRight:10, 
						borderLeftWidth:0, 
						marginTop:0, 
						alignContent:'center'
						}}>
						<MyButton 
							btnText="Custom date" 
							btnBorClr={darkColour}
							btnBorRadius={10}
							btnBorWdt={2}
							btnColor={whoClicked === 'custom' ? darkColour : 'white'}
							btnFontSize={15}
							btnHeight={32}
							btnWidth={110}
							btnTxtClr={whoClicked === 'custom' ? 'white' : darkColour}
							btnPadding={4}
							hndClicked={customClicked}
						 />
					</View>
				</View>
			</View>
						
					
					<View style={{width:664, height:40, backgroundColor:'white', alignSelf:'center', paddingRight:20}}>
					{checkedItems.some((item) => item) && (
							<View style={{alignSelf:'flex-end', width:200, height:40}}>
								<MyButton 
								btnText ="Delete Selected"
								btnBorClr={darkColour}
								btnBorRadius={10}
								btnBorWdt={0}
								btnColor={darkColour}
								btnFontSize={15}
								btnHeight={40}
								btnWidth={200}
								btnTxtClr="white"
								hndClicked={deleteCheckedItems}
								
								/>
							</View>
							
						)}		
					</View>
        </View>

				<View style={{
					width:1560, 
					height:654, 
					borderWidth:2, 
					borderBottomWidth:0,
					borderColor:'#DCE3E8', 
					marginTop:10, 
					marginBottom:0, 
					borderRadius:10,
					borderBottomLeftRadius:0,
					borderBottomRightRadius:0,
					marginLeft:20, 
					marginRight:20, 
					backgroundColor:'white'
					}}>
				
					<View style={{width:1560, 
					height:35, 
					backgroundColor: darkColour, 
					flexDirection:'row', 
					borderTopLeftRadius:10, 
					borderTopRightRadius:10
					}}>
						<View style={{...stylesBox.columnHeaderBox,  marginLeft: isSwitchOn ? 34 : -2}}>
							<Text style={{...stylesBox.columnHeaderText}}>
								Qty
							</Text>
						</View>
						<View style={{...stylesBox.columnHeaderBox, width:331}}>
							<Text style={{...stylesBox.columnHeaderText}}>
								Board Description
							</Text>
						</View>
						<View style={{...stylesBox.columnHeaderBox, width:185}}>
							<Text style={{...stylesBox.columnHeaderText}}>
								Customer
							</Text>
						</View>
						<View style={{...stylesBox.columnHeaderBox, width:117}}>
							<Text style={{...stylesBox.columnHeaderText}}>
								Delivery Status
							</Text>
						</View>
						<View style={{...stylesBox.columnHeaderBox, width: isSwitchOn ? 300 : 336}}>
							<Text style={{...stylesBox.columnHeaderText}}>
								Remark
							</Text>
						</View>
						<View style={{...stylesBox.columnHeaderBox, width:102}}>
							<Text style={{...stylesBox.columnHeaderText}}>
								Amount (₦)
							</Text>
						</View>
						<View style={{...stylesBox.columnHeaderBox, width:152}}>
							<Text style={{...stylesBox.columnHeaderText}}>
								Sum Total (₦)
							</Text>
						</View>
						<View style={{...stylesBox.columnHeaderBox, width:120}}>
							<Text style={{...stylesBox.columnHeaderText}}>
								Discount (₦)
							</Text>
						</View>
						<View style={{...stylesBox.columnHeaderBox, width:180}}>
							<Text style={{...stylesBox.columnHeaderText}}>
								Final Payment (₦)
							</Text>
						</View>
				</View>
				{ showLoadingIndicator  ? (
				<ActivityIndicator size="large" color= {darkColour} style ={{ marginTop: 280}} />
				) : (
					<FlatList
					style={{width:1556, height:617}}
					data={filteredResult}
					keyExtractor={(item) => item.id.toString()}
					renderItem={({ item, index }) => (
						<ChildView
							key={item.id}
							texts={[
								item.quantity ? item.quantity.toString() : '0',
								item.board,
								item.customer,
								item.delivered,
								item.notes,
								item.itemPrice ? Number(item.itemPrice).toLocaleString('en-NG') : '0.00',
								item.total ? Number(item.total).toLocaleString('en-NG') : '0.00',
								item.discount ? Number(item.discount)?.toLocaleString('en-NG') : '0.00',
								item.afterDiscount ? Number(item.afterDiscount)?.toLocaleString('en-NG') : '0.00'
							]}
							isChecked={deleteArrayID.includes(item.id) ? true : false}
							onCheckboxChange={(value) => handleCheckboxChange(index, value, item.id)}
							showCheckbox={isSwitchOn}
							index={index}
							id={item.id}
							Delivered={item.delivered === 'Yes' ? false : true}
							noClicked={() => SmallDialog(item.id.toString())}
						/>
					)}
				/>
				 )}
				<Portal>
              <Modal visible={showModal} onDismiss={() => {setShowModal(false); setOneItemID('')}} 
							dismissable = {false} contentContainerStyle={stylesBox.modalContainer}>
                <View>
                  <View style ={stylesBox.modalChild}>
										<View style ={{ flexDirection: 'row',  marginTop: 10, marginLeft: 15}}>
											 <Text style={{...stylesBox.mediumText, fontSize:16, color: darkColour, alignSelf: 'flex-start', fontWeight:'900' }}>
											Update Delivered Status
										</Text>
										
										</View>
										<View style ={{ flexDirection: 'row',  marginTop: 5, marginLeft: 15}}>
											
										<Text style={{...stylesBox.columnHeaderText, color:darkColour, textAlign:'left'}}>
											By clicking yes, you are confirming this sales as delivered
										</Text>
										</View>
                   
										
                   
                    <View style={{...stylesBox.modalButtonContainer, alignSelf:'flex-end', marginTop:15 }}>
                      <View style = {{marginHorizontal: 10}}>
                        <MyButton btnText="Yes" btnWidth={100} hndClicked={() => updateDeliveryStatus(oneItemID)} />
                      </View>
											<View>
                        <MyButton btnText="Cancel" btnWidth={100} btnColor="white" btnTxtClr= {darkColour} btnBorWdt={2} btnPadding={8}
												hndClicked={()=> setShowModal(false)}
												/>
                      </View>
                    </View>
                  </View>
                </View>
              </Modal>
            </Portal>

    </View>
		{dateVisible &&
		<View style={{marginTop:-60, marginLeft:50, top:72, left: 880, position: 'absolute'}}>
      <DateModule appearUp ={false} onNewDateSelected={searchDateSelected}/>
    </View> 
		}

							<View style = {stylesBox.boxFooterText}>
								<View style = {{flex: 1, justifyContent: 'center'}}>
									<Text style={{ ...stylesBox.columnHeaderText, marginTop: 0, marginLeft: 10, alignSelf: 'flex-start' }}>
										{footerText}
									</Text>
								</View>
								<View style = {{flex: 2, flexDirection: 'row', justifyContent: 'flex-end', marginRight: -4}}>
									<Text style={{...stylesBox.columnHeaderText, color:'white', paddingTop:3, marginLeft: 100}}>
										Gross Sales Revenue for this duration 
									</Text>
									<IconButton
										icon="ray-start-arrow"
										iconColor= 'white'
										size={40}
										focusable={false}
										style={{marginRight:90, marginLeft: 50, marginTop:-8}}
									/>
									<View style = {{...stylesBox.boxFooterTotal, width: 120}}>
										<Text style={{ ...stylesBox.columnHeaderText, marginTop: 0, alignSelf: 'center'}}>
										{Number(discount ? discount : '0').toLocaleString('en-NG', { style: 'currency', currency: 'NGN' })}
										</Text>
									</View>
									<View style = { stylesBox.boxFooterTotal}>
										<Text style={{ ...stylesBox.columnHeaderText, marginTop: 0, alignSelf: 'center'}}>
										{Number(grossTotal ? grossTotal : '0').toLocaleString('en-NG', { style: 'currency', currency: 'NGN' })}
										</Text>
									</View>
								</View>
                
								
              </View>

		
  </View>
	</PaperProvider>
    )
}

const stylesBox=StyleSheet.create ({
	columnHeaderText: {
    fontFamily:'century gothic', 
    fontSize:15, 
    fontWeight:'normal', 
    textAlign:'center',
    color:'white', 
    marginTop:6
    },

		columnHeaderBox: {
			borderWidth:2, 
			borderColor:'black', 
			width:57,  
			height:35, 
			alignItems:'center',
			marginLeft:-2,
			borderTopWidth:0,
			
		},
		mediumText: {
      color:'grey', 
      fontFamily:'century gothic', 
      fontSize:15, 
      fontWeight:'normal', 
      textAlign:'center',
      marginTop:5
      },
		modalChild: {
			width: 400, 
			height:150, 
			borderWidth:2, 
			borderRadius:10, 
			borderColor:darkColour, 
			backgroundColor:'white',
		},
		modalButtonContainer: {
			width:400, 
			flexDirection:'row-reverse', 
			paddingRight:0
		},
		modalContainer: {
			marginLeft:600,
			marginTop: -50,
			justifyContent: 'center',
			alignItems: 'center',
			backgroundColor: 'white',
			flexDirection:'column-reverse', 
			width:400, 
			height:150, 
			borderWidth:1, 
			borderColor:darkColour, 
			borderRadius:10, 
		},
		boxFooterText: {
			width: 1560, 
			height: 40, 
			marginHorizontal: 20,
			flexDirection: 'row', 
			backgroundColor: darkColour, 
			borderBottomRightRadius: 10, 
			borderBottomLeftRadius: 10, 
			justifyContent: 'flex-start'
		},
		boxFooterTotal: {
			width: 180, 
			borderWidth: 2, 
			borderColor: 'white', 
			marginLeft: -2, 
			borderTopWidth: 0, 
			borderBottomWidth: 0, 
			justifyContent: 'center',
			
		},
	})

export default Sales